import { Component, OnInit, Self } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { consumerBasicInfoModel } from '../../models/consumerBasicInfo/consumerBasicInfo.model';
import { loadListModel } from '../../models/loadList/loadListModel';
import { BlroModel } from '../../models/blro/blro.model';
import { MauzaModel } from '../../models/mauza/mauza.model';
import { PurposeSupplyModel } from '../../models/purposeOfSupply/purpose.supply.model';
import { PowerSupplyModel } from '../../models/powerSupply/power.supply.model';
import { CatagoryTypeModel } from '../../models/catagoryType/catagory.type.model';
import { ConnectionTypeModel } from '../../models/connetionType/connection.type.model';
import { AppliedPhaseModel } from '../../models/appliedPhase/applied.phase.model';
import * as $ from 'jquery';
import { Observable } from 'rxjs/Observable';
import { PrefixModel } from 'app/models/prefixModel/prefixModel';
import { disableDebugTools } from '@angular/platform-browser';

@Component({
  selector: 'app-newnsc',
  templateUrl: './consumerBasicInfo.component.html'
})
export class ConsumerBasicInfoComponent implements OnInit {
  public checkboxChecked: boolean = false;
  public errorMsg: string = "";
  public successMsg: string = "";
  public sessionData: any;
  public consumerBasicInfoModel: consumerBasicInfoModel = new consumerBasicInfoModel;
  public loadListModel: loadListModel = new loadListModel;
  public purposeSupplyListLT: PurposeSupplyModel;
  public purposeSupplyListHTT: PurposeSupplyModel;
  public serviceOn: boolean = false;
  public showTranscId: boolean;
  public hideOtp: boolean;
  public blroID: number;
  public transcId: string;
  public isDisable: boolean;
  public isHide: boolean;
  public emd: number;
  public isConsumerBasic: boolean;
  public isChecked: boolean = false;
  public isTermsCond: boolean = false;
  public isSubmit: boolean = true;
  public isSubmitProceed: boolean = true;
  public isLoadCalc: boolean = true;
  public isProceed: boolean = true;
  public isDisableProced: boolean = true;
  public isDisableForm: boolean = true;
  public isHideLoadCalc: boolean = true;
  public isPurposeSupplyLT: boolean = true;
  public isPurposeSupplyHT: boolean = true;
  public isHideCheckBox: boolean = false;
  public isDefault: boolean = false;
  public popupopen: boolean = true;
  public totalLoadData: any;
  public isDisableCount: boolean = true;
  public isDisableAppliedLoad: boolean = true;
  public isHideLoadListData: boolean = true;
  public isTrueCheckBox: String;
  public isCheckBox: boolean;
  public isHideConsumerDetails: boolean = false;
  public isHideConsumerDetailsPreview: boolean = true;
  public isHideLoadCalculator: boolean = true;
  public isHideLink: boolean = true;
  public isConfirm: boolean = false;
  public isHideLoad: boolean = true;
  //public disableClickToView : boolean = false;
  public disableClickToView: boolean = true;
  mauzaData: string;
  mauzaListVal: any;
  index: any = 0;
  public purposeOfSupplyId: number;
  blroList: any;
  mauzaList: any = [];
  abcList: Array<string> = [];
  prefixList: any;
  purposeSupplyListLow: any;
  purposeSupplyListHigh: any;
  powerSupplyList: any;
  connectonList: any;
  catagoryList: any;
  appliedPhaseList: any;
  selectedBlro: BlroModel = new BlroModel();
  prefixModel: PrefixModel = new PrefixModel();
  selectedMauza: MauzaModel = new MauzaModel();
  selectedPurposeSupply: PurposeSupplyModel = new PurposeSupplyModel();
  selectedPowerSupply: PowerSupplyModel = new PowerSupplyModel();
  selectedVoltage: PurposeSupplyModel = new PurposeSupplyModel();
  selectedCatagoryType: CatagoryTypeModel = new CatagoryTypeModel();
  selectedConnectionType: ConnectionTypeModel = new ConnectionTypeModel();
  selectedAppliedPhase: AppliedPhaseModel = new AppliedPhaseModel();
  selectedLoadList: loadListModel = new loadListModel();
  voltageLevel: string;
  powerSupply: string;
  cfl: number;
  load: any;
  is_edit: boolean = true;
  incdntLamp: number;
  totalLoad: number = 0;
  counter: number = 0;
  selectedPowerSupplyID: number;
  applianceId: number;
  loadListData: any;
  loadInKw: any;
  totalApplienceCount: number = 0;
  applianceName: string;
  applianceWatt: number;
  applianceCount: number;
  isHideAppliedLoad: boolean = false;
  isDisableCheckBox: boolean = true;
  lastTotalApplienceCount: number;
  sTbState: string = 'invisible';
  countVal: {
    applianceId: 0,
    status: true
  };
  isEdit: any;
  loadListSubmit: any[] = [{
    applianceId: null,
    applianceName: null,
    applianceWatt: null,
    applianceCount: null,

  }];
  loadListPopup: any[] = [{
    applianceId: null,
    applianceName: null,
    applianceWatt: null,
    applianceCount: null,

  }];

  constructor(public http: HttpTestService, public session: sessionServices, public router: Router, private route: ActivatedRoute) {
    this.showTranscId = false;
    this.hideOtp = true;
    this.isDisable = true;
    this.isConsumerBasic = false;
    this.transcId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    var self = this;
    this.prefixModel.solutaionPrefixCode = '';
    this.selectedBlro.blroId = null;
    this.selectedBlro.blroName = '';
    this.selectedMauza.mauzaName == '';
    this.selectedMauza.mauzaId == null;
    this.consumerBasicInfoModel.city == '';
    this.consumerBasicInfoModel.district == '';
    this.selectedPowerSupply.psId == null;
    this.selectedPowerSupply.powerSupplyType == '';
    this.selectedCatagoryType.catId == null;
    this.selectedCatagoryType.catType == '';
    this.selectedPurposeSupply.suppId == null;
    this.selectedPurposeSupply.suppLoad == '';
    // this.selectedLoadList.applianceCount ==null;
    this.selectedAppliedPhase.phaseId == null;
    this.selectedAppliedPhase.phaseType == '';
    this.selectedConnectionType.conId == null;
    this.selectedConnectionType.connName == null;
    this.consumerBasicInfoModel.appliedLoad == null;

    document.getElementById("id1").style.display = "none";
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };


    // self.http.getConsumerInfo(this.transcId).subscribe(

    //   (data : consumerBasicInfoModel) => {
    //     alert("EMD");
    //     self.emd = data.emdValue;

    //   },
    //   (error) => {
    //    // self.errorMsg = error;
    //   },

    //   () => {

    //   }
    // )     

    this.retrivePurposeOfSupply(1);
    this.retrivePurposeOfSupply(2);
    //=======FOR PREFIX DROPDOWN============= 
    self.http.getPrefixList().subscribe((data) => {
      self.prefixList = data;
    },
      (error) => {
        self.errorMsg = error;
      },
      () => {
      }
    )


    //=======FOR BLRO DROPDOWN============= 
    //  self.http.getBlroList().subscribe(

    //    (data) => {

    //      self.blroList = data;
    //    },
    //    (error) => {
    //      self.errorMsg = error;
    //    },

    //    () => {

    //    }
    //  )

    self.http.getAllBlroRegion().subscribe(
      (data) => {
        self.blroList = data;
      },
      (error) => {
        self.errorMsg = error;
      });

    self.http.getAllPowerSupplyList().subscribe(
      (data) => {
        self.powerSupplyList = data;
      },
      (error) => {
        self.errorMsg = error;
      });


    //=======FOR CONNECTION TYPE DROPDOWN============= 
    self.http.getConnetonTypeList().subscribe(
      (data) => {
        self.connectonList = data;
      },
      (error) => {
        self.errorMsg = error;
      });

    //=======FOR CATAGORY TYPE DROPDOWN============= 
    self.http.getCatagoryTypeList().subscribe(
      (data) => {
        self.catagoryList = data;
      },
      (error) => {
        self.errorMsg = error;
      })

    //=======FOR APPLIED PHASE DROPDOWN============= 
    self.http.getAppliedPhaseList().subscribe(
      (data) => {
        self.appliedPhaseList = data;
      },
      (error) => {
        self.errorMsg = error;
      })

    // Get All Load Data
    self.http.getAllLoadData().subscribe(
      (data) => {
        self.loadListPopup = data;
      },
      (error) => {
        self.errorMsg = error;
      });
  }

  onSelectPrefix(prefixName) {
    this.prefixModel.solutaionPrefixCode = prefixName;
  }

  openPopup = function () {
    this.popupopen = false;
  }

  closePopup = function () {
    this.popupopen = true;
  }

  calculateLoad = function () {
    this.totalApplienceCount = this.loadList.applianceCount;
    alert("Total Applience Count: " + this.totalApplienceCount);
    alert("Total Count: " + this.loadList.applianceCount);
    for (var i = 0; i < this.loadList.length; i++) {
      // this.loadList[i].totalApplianceLoadKw = this.loadList[i].applianceWatt*this.loadList[i].applianceCount;
      this.loadList[i].transactionId = this.transcId;
    }

    this.http.postLoadDetails(this.loadList).subscribe((data) => {
      this.loadListData = data;
      // this.totalApplienceCount = this.load.applianceCount;

    },
      (error) => {

      },
      () => {


      }
    );
    this.lastTotalApplienceCount = this.totalApplienceCount;
  }

  valuechange(index, updatedCount) {
    this.totalLoad = 0;
    this.loadListPopup.forEach((listItem, i) => {
      if (i == index) {
        listItem.applianceCount = updatedCount;
      }
      this.totalLoad += (listItem.applianceWatt * (typeof listItem.applianceCount == 'undefined' ? 0 : listItem.applianceCount) / 1000);
    });


    // this.totalLoad = count*600;


    //alert("Count"+this.totalLoad)
    // if(count !=null){
    //    this.counter = this.counter + 1;

    //    if(this.counter == 0 || this.counter == 1){
    //      this.disableClickToView = true;
    //      this.isConfirm = true;
    //    }else{
    //      this.disableClickToView = false;
    //    }
    // }else if(count ==null){
    //    this.counter = this.counter - 1;

    //    if(this.counter == 0 || this.counter == 1){
    //       this.disableClickToView = true;
    //       this.isConfirm = true;
    //   }else{
    //     this.disableClickToView = false;
    //   }
    // }
  }

  selectCheckBox = function (id) {
    this.applianceId = id;

    if (this.applianceId == 1) {
      this.isDisableCount = false;
    } else if (this.applianceId == 2) {
    } else if (this.applianceId == 3) {
      this.isDisableCount = false;
    }

    if (this.applianceId == 1) {
      this.isDisableCount = false;
    } else if (this.applianceId == 2) {
      this.isDisableCount = false;
    } else {
      this.isDisableCount = true;
    }

    // this.isEdit = id
    //this.countVal.applianceId = id;
    //this.countVal.status = false;

    //     if(e.target.checked){
    //       this.isDisableCount = false;
    //  }else{
    //   this.isDisableCount = true;
    //  }
  }
  // onSelect(blroId) {

  //   var self = this;
  //   this.selectedBlro = new BlroModel();
  //   this.selectedBlro.blroId = blroId;
  //   self.http.getMouzaList(this.selectedBlro.blroId).subscribe(
  //     (data) => {
  //       self.mauzaList = [];
  //       self.mauzaList = data;
  //     },
  //     (error) => {
  //       self.errorMsg = error;
  //     },

  //     () => {

  //     }
  //   )
  // }

  onSelect(blroId) {
    var self = this;
    this.selectedBlro = new BlroModel();
    this.selectedBlro.blroId = blroId;
    self.mauzaList = [];
    self.http.getZoneByBlroRegionId(this.selectedBlro.blroId).subscribe(
      (data) => {
        self.mauzaList = data;
      },
      (error) => {
        self.errorMsg = error;
    });
  }

  onSelectMauza(mauzaId) {
    var self = this;
    this.selectedMauza = new MauzaModel();
    this.selectedMauza.mauzaId = mauzaId;
  }

  onSelectPurpose(purposeId) {
    this.purposeOfSupplyId = purposeId;
    if (this.selectedPowerSupply.psId == 1) {
      this.purposeSupplyListLow = this.purposeSupplyListLT;
      for (var i = 0; i < this.purposeSupplyListLow.length; i++) {
        if (this.purposeSupplyListLow[i].suppId == purposeId) {
          if (this.purposeSupplyListLow[i].suppId == 1) {
            //this.isDisableAppliedLoad = true
            this.emd = this.purposeSupplyListLow[i].emdAmount;
            this.isHideAppliedLoad = false;
            this.isDisableAppliedLoad = false;
            this.isHideAppliedLoad = false;
            this.isHideLoadCalc = true;
            this.isHideLoadListData = false;
            this.isHideLink = false;
          } else if (this.purposeSupplyListLow[i].suppId == 2) {
            document.getElementById("id1").style.display = "none";
            this.emd = this.purposeSupplyListLow[i].emdAmount;
            this.isDisableAppliedLoad = false;
            this.isHideAppliedLoad = false;
            this.isHideLoadCalc = true;
            this.isHideLoadListData = true;
            this.isHideLink = true;
          } else if (this.purposeSupplyListLow[i].suppId == 3) {
            document.getElementById("id1").style.display = "none";
            this.emd = this.purposeSupplyListLow[i].emdAmount;
            this.isDisableAppliedLoad = false;
            this.isHideLoadListData = true;
            this.isHideLoadCalc = true;
            this.isHideLink = true;
          }
          this.voltageLevel = this.purposeSupplyListLow[i].voltageLevel;
          this.isHideLoadCalc = false;
        }
      }
    } else if (this.selectedPowerSupply.psId == 2) {
      this.purposeSupplyListHigh = this.purposeSupplyListHTT;
      for (var i = 0; i < this.purposeSupplyListHigh.length; i++) {
        if (this.purposeSupplyListHigh[i].suppId == purposeId) {
          this.emd = this.purposeSupplyListHigh[i].emdAmount;
          this.voltageLevel = this.purposeSupplyListHigh[i].voltageLevel;
          this.isHideLoadCalc = false;
        }
      }
      this.isHideLoadCalc = true;
    } else {
      this.isHideLoadCalc = true;
    }
  }

  onSelectPowerSupply(purposeId) {
    var self = this;
    this.selectedPowerSupply = new PowerSupplyModel();
    this.selectedPowerSupply.psId = purposeId;
    if (this.selectedPowerSupply.psId == 1) {
      this.isPurposeSupplyLT = false;
      this.isPurposeSupplyHT = true;
      this.isDefault = true;
      this.isHideAppliedLoad = false;
      this.isDisableAppliedLoad = true;
    }
    else if (this.selectedPowerSupply.psId == 2) {
      this.isPurposeSupplyLT = true;
      this.isPurposeSupplyHT = false;
      this.isDefault = true;
      this.isHideAppliedLoad = false;
      this.isDisableAppliedLoad = false;
    }
    this.selectedPowerSupplyID = this.selectedPowerSupply.psId;
  }

  retrivePurposeOfSupply = function (powerSupplyTypeId) {
    var self = this;
    self.http.getPurposeSupplyList(powerSupplyTypeId).subscribe((data: PurposeSupplyModel) => {
      if (powerSupplyTypeId == 1) {
        this.purposeSupplyListLT = data;
        this.isHideAppliedLoad = false;
        this.isDisableAppliedLoad = true;
      } else if (powerSupplyTypeId == 2) {
        this.purposeSupplyListHTT = data;
        this.isHideAppliedLoad = false;
        this.isDisableAppliedLoad = false;
      }
    },
    (error) => {
      self.errorMsg = error;
    });
  }

  onSelectCatagory(catagoryId) {
    this.selectedCatagoryType = null;
    for (var i = 0; i < this.catagoryList.length; i++) {
      if (this.catagoryList[i].catId == catagoryId) {
        this.selectedCatagoryType = this.catagoryList[i];
      }
    }
  }

  onSelectConnection(connId) {
    this.selectedConnectionType = null;
    for (var i = 0; i < this.connectonList.length; i++) {
      if (this.connectonList[i].conId == connId) {
        this.selectedConnectionType = this.connectonList[i];
      }
    }
  }

  onSelectAppliedPhase(phaseId) {
    this.selectedAppliedPhase = null;
    for (var i = 0; i < this.appliedPhaseList.length; i++) {
      if (this.appliedPhaseList[i].phaseId == phaseId) {
        this.selectedAppliedPhase = this.appliedPhaseList[i];
      }
    }
  }

  public consumerBasicPostData = {
    "transactionId": null,
    "firstName": null,
    "lastName": null,
    "blroId": null,
    "mouza": null,
    "address1": null,
    "address2": null,
    "address3": null,
    "houseNumber": null,
    "postalCode": null,
    "city": null,
    "suppId": null,
    "catId": null,
    "conId": null,
    "phaseId": null,
    "appliedLoad": null,
    "psId": null,
    "voltage": null,
    "careOfName": null,
    "solutaionPrefixCode": null,
    "address4": null,
    "address5": null,
    "district": null,
    "count": null,
    "totalApplianceLoadKw": null
  }

  public consumerAndApplienceInfoModel =
    {
      "consumerBasicPostDataModel": null,
      "loadList": null
  }

  public loadPostData = {
    "cfl": null,
    "incdntLamp": null
  }

  sendMobileOtpReq = function () {
    var self = this;
    self.serviceOn = true;
    self.newNscPostData.newUserMob = self.newnscModel.newUserMob;
    this.showTranscId = true;
    this.hideOtp = false;
  }

  sendTranscReq = function () {
    var self = this;
    self.router.navigateByUrl(['/newNscRegCompnt'], { skipLocationChange: false });
  }

  showAppliedLoad = function () {
    //   for(var i = 0;i < this.loadListPopup.length ;i++ ){
    //     // this.loadList[i].totalApplianceLoadKw = this.loadList[i].applianceWatt*this.loadList[i].applianceCount;

    //     this.loadListPopup[i].transactionId = this.transcId;
    //    }
    //   this.http.postLoadDetails(this.loadListPopup).subscribe((data) => {
    //     this.loadListData = data;
    //     this.loadInKw =  this.loadListData/1000;
    //   },
    //   (error) => {
  }

  checkValue = function (event: any) {
    if (event.target.checked) {
      this.isDisable = false;
    }
    else {
      this.isDisable = true;
    }
  }

  changeValue(event: any) {
    if (event.trim().length == 0) {
      this.isHideCheckBox = true;
    }
    else {
      this.isHideCheckBox = false;
    }
  }

  changePostalCode(event: any) {
    if (event.trim().length != 6) {
      this.isHideCheckBox = true;
    }
    else {
      this.isHideCheckBox = false;
    }
  }

  // checkFormDisable = function () {
  //   var self = this;
  //   if(self.consumerBasicInfoModel.careOfName != null &&
  //    self.consumerBasicInfoModel.firstName != null 
  //    && self.consumerBasicInfoModel.lastName != null 
  //    && self.selectedBlro.blroId != null && self.selectedMauza.mauzaId != null 
  //    && self.consumerBasicInfoModel.address1 != null && self.consumerBasicInfoModel.postalCode != null &&
  //    self.consumerBasicInfoModel.city != null  && self.selectedCatagoryType.catId != null &&
  //    self.selectedPurposeSupply.suppId != null && self.selectedConnectionType.conId != null
  //    &&  self.selectedAppliedPhase.phaseId != null  &&
  //    self.selectedPowerSupply.psId != null && self.consumerBasicInfoModel.careOfName != null 
  //    &&  self.prefixModel.solutaionPrefixCode != null && self.consumerBasicInfoModel.district != null &&
  //    self.voltageLevel != null && this.consumerBasicInfoModel.appliedLoad != null){

  //   if(self.consumerBasicInfoModel.careOfName == null ||
  //     self.consumerBasicInfoModel.firstName == null 
  //     || self.consumerBasicInfoModel.lastName == null 
  //     || self.selectedBlro.blroId == null || self.selectedMauza.mauzaId == null 
  //     || self.consumerBasicInfoModel.address1 == null || self.consumerBasicInfoModel.postalCode == null ||
  //     self.consumerBasicInfoModel.city == null  || self.selectedCatagoryType.catId == null ||
  //     self.selectedPurposeSupply.suppId == null || self.selectedConnectionType.conId == null
  //     ||  self.selectedAppliedPhase.phaseId == null  ||
  //     self.selectedPowerSupply.psId == null || self.consumerBasicInfoModel.careOfName == null 
  //     ||  self.prefixModel.solutaionPrefixCode == null || self.consumerBasicInfoModel.district == null ||
  //     self.voltageLevel == null || this.consumerBasicInfoModel.appliedLoad == null){
  //         this.isHideCheckBox = true;
  //     }

  //     if(self.selectedPurposeSupply.suppId === 1){
  //     return this.isDisableForm = false; 
  //   }

  //   else if(self.selectedPurposeSupply.suppId === 2){
  //     if(self.consumerBasicInfoModel.appliedLoad != undefined && self.consumerBasicInfoModel.appliedLoad != "" && self.consumerBasicInfoModel.appliedLoad != null){
  //       return this.isDisableForm = false; //active
  //     }else {
  //       return this.isDisableForm = true; //not active
  //     }
  //   }     
  //   else if(self.selectedPurposeSupply.suppId === 3){
  //     if(self.consumerBasicInfoModel.appliedLoad != undefined && self.consumerBasicInfoModel.appliedLoad != "" && self.consumerBasicInfoModel.appliedLoad != null){
  //         return this.isDisableForm = false; //active
  //       }else {
  //         return this.isDisableForm = true; //not active
  //       }
  //     }     
  //   }else{
  //     return this.isDisableForm = true; 
  //   }
  //  return true;

  // }

  checkFormDisable = function (formValid: boolean) {
    if (formValid) {
      if (!this.checkboxChecked) {
        this.isSubmitProceed = true;
        this.isSubmit = true;
      }
      return false;
    } else if (formValid == false) {
      this.checkboxChecked = false;
      if (!this.checkboxChecked) {
        this.isSubmitProceed = true;
        this.isSubmit = true;
      }
      return true;
    } else {
      return false;
    }
  }

  sendConsumerInfo = function () {
    window.scroll(2, 2);
    var self = this;
    self.errorMsg = "";
    self.successMsg = "";
    self.isHide = true;

    var consumerData = this.selectedPowerSupplyID + "," + this.transcId + "," + this.purposeOfSupplyId;
    self.consumerBasicPostData.transactionId = this.transcId;
    self.consumerBasicPostData.firstName = self.consumerBasicInfoModel.firstName;
    self.consumerBasicPostData.lastName = self.consumerBasicInfoModel.lastName;
    self.consumerBasicPostData.blroId = self.selectedBlro.blroId;
    self.consumerBasicPostData.mauzaId = self.selectedMauza.mauzaId;
    self.consumerBasicPostData.address1 = self.consumerBasicInfoModel.address1;
    self.consumerBasicPostData.address2 = self.consumerBasicInfoModel.address2;
    self.consumerBasicPostData.address3 = self.consumerBasicInfoModel.address3;
    self.consumerBasicPostData.houseNumber = self.consumerBasicInfoModel.houseNumber;
    self.consumerBasicPostData.postalCode = self.consumerBasicInfoModel.postalCode;
    self.consumerBasicPostData.city = self.consumerBasicInfoModel.city;
    self.consumerBasicPostData.suppId = self.selectedPurposeSupply.suppId;
    self.consumerBasicPostData.catId = self.selectedCatagoryType.catId;
    self.consumerBasicPostData.conId = self.selectedConnectionType.conId;
    self.consumerBasicPostData.phaseId = self.selectedAppliedPhase.phaseId;
    self.consumerBasicPostData.appliedLoad = self.consumerBasicInfoModel.appliedLoad;
    self.consumerBasicPostData.psId = self.selectedPowerSupply.psId;
    self.consumerBasicPostData.voltage = self.voltageLevel;
    self.consumerBasicPostData.careOfName = self.consumerBasicInfoModel.careOfName;
    self.consumerBasicPostData.solutaionPrefixCode = self.prefixModel.solutaionPrefixCode;
    self.consumerBasicPostData.address4 = self.consumerBasicInfoModel.address4;
    self.consumerBasicPostData.address5 = self.consumerBasicInfoModel.address5;
    self.consumerBasicPostData.district = self.consumerBasicInfoModel.district;
    if (self.consumerBasicPostData.blroId == null) {
      self.errorMsg = "Select BLRO";
      // this.isDisable=false;
    }

    self.consumerAndApplienceInfoModel.consumerInfo = self.consumerBasicPostData;
    self.consumerAndApplienceInfoModel.consumerApplienceLoadList = this.loadList;
    self.http.postConsumerBasicDetails(self.consumerAndApplienceInfoModel).subscribe(
      (data) => {
        self.CreateUserResponseData = data;
        document.getElementById("consumerDetails").style.display = "none";
        self.router.navigate(['/documentUploadComponent', consumerData], { skipLocationChange: false });
        },
        (error) => {
          self.errorMsg = error;
        },
        () => {
          self.successMsg = "You have successfully submitted the Consumer Basic Information request.We will contact you soon.";
          self.serviceOn = false;
          self.consumerBasicInfoModel.firstName = "";
          self.consumerBasicInfoModel.lastName = "";
          self.consumerBasicInfoModel.blro = "";
          self.consumerBasicInfoModel.mouza = "";
          self.consumerBasicInfoModel.address1 = "";
          self.consumerBasicInfoModel.address2 = "";
          self.consumerBasicInfoModel.address3 = "";
          self.consumerBasicInfoModel.houseNumber = "";
          self.consumerBasicInfoModel.postalCode = "";
          self.consumerBasicInfoModel.city = "";
          self.consumerBasicInfoModel.suppId = "";
          self.consumerBasicInfoModel.conId = "";
          self.consumerBasicInfoModel.catId = "";
          self.consumerBasicInfoModel.phaseId = "";
          self.consumerBasicInfoModel.appliedLoad = "";
          self.consumerBasicInfoModel.voltage = "";
          self.serviceOn = true;
        }
      );

  self.http.getBlroList().subscribe(
      (data) => {
        self.nameList = data;
      },
      (error) => {
        self.errorMsg = error;
      });
  }

  showTermsCondtn = function () {
    var self = this;
    self.isSubmitProceed = true;
    self.isTermsCond = true;
    self.isSubmit = true;
  }

  sendConsumer = function (e, el) {
    var self = this;
    self.isSubmitProceed = true;
    self.isSubmit = false;
    self.isHideConsumerDetails = true;
    self.isHideConsumerDetailsPreview = false;
    this.sTbState = (this.sTbState === 'invisible' ? 'visible' : 'invisible');
    if (this.sTbState === 'visible') {
      el.focus();
    }
  }

  closePopupAgreeTermsConditn() {
    var self = this;
    self.isTermsCond = false;
    self.isSubmitProceed = false;
    document.getElementById("id1").style.display = "none";
  }

  closePopupAgree = function () {
    var self = this;
    self.isTermsCond = false;
    self.isSubmitProceed = true;
    document.getElementById("id1").style.display = "none";

    //   for(var i = 0;i < this.loadListPopup.length ;i++ ){
    //  // this.loadList[i].totalApplianceLoadKw = this.loadList[i].applianceWatt*this.loadList[i].applianceCount;
    //  this.loadListPopup[i].transactionId = this.transcId;
    // }

    // this.loadListPopup.forEach(i => {
    //    this.loadListSubmit.push({
    //     "applianceId" : i.applianceId,
    //     "applianceName": i.applianceName,
    //     "applianceWatt" : i.applianceWatt,
    //     "applianceCount" : i.applianceCount,
    //    });
    // }); 
    //   this.http.postLoadDetails(this.loadListSubmit).subscribe((data) => {
    //     this.loadListData = data;
    //     this.loadInKw =  this.loadListData;
    //   },
    //   (error) => {

    //   },
    //   () => {


    //   }
    // );
  }

  closePopupButton = function () {
    this.isTermsCond = false;
    document.getElementById("id1").style.display = "none";
  }

  closePopupDisagree = function () {
    var self = this;
    self.isTermsCond = false;
    self.isSubmitProceed = true;
    document.getElementById("id1").style.display = "none";
  }

  toggle = function () {
    this.isLoadCalc = false;
  }

  clickAppliedLoad = function () {
    this.isHideLoadCalculator = false;
    // this.router.navigate(['/consumerBasicInfot'],{ skipLocationChange: false });
    document.getElementById("id1").style.display = "block";
    // this.isHideLink = false;
  }

  ConvertToInt(val) {
    return parseInt(val);
  }

  onSearchChange() {
    let cflVal: number = 0;
    let inLamp: number = 0;
    let inLampOne: number = 0;
    let inLampTwo: number = 0;
    let tubeLight: number = 0;

    cflVal = this.ConvertToInt((<HTMLInputElement>document.getElementById("cflText")).value);
    inLamp = this.ConvertToInt((<HTMLInputElement>document.getElementById("inLampText")).value);
    inLampOne = this.ConvertToInt((<HTMLInputElement>document.getElementById("inLampText1")).value);
    inLampTwo = this.ConvertToInt((<HTMLInputElement>document.getElementById("inLampText2")).value);
    tubeLight = this.ConvertToInt((<HTMLInputElement>document.getElementById("tubeText")).value);

    var num = isNaN(cflVal) ? 0 : cflVal;
    var num1 = isNaN(inLamp) ? 0 : inLamp;
    var num2 = isNaN(inLampOne) ? 0 : inLampOne;
    var num3 = isNaN(inLampTwo) ? 0 : inLampTwo;
    var num4 = isNaN(tubeLight) ? 0 : tubeLight;
    this.totalLoad = this.ConvertToInt(num) * 18 + this.ConvertToInt(num1) * 40 + this.ConvertToInt(num2) * 60 + this.ConvertToInt(num3) * 100 + this.ConvertToInt(num4) * 40;
  }
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/consumerBasicInfo/consumerBasicInfo.component.ts